// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shot_wrapper[data-v-47ce0944]{height:100%;padding:10px 20px 0}", ""]);
// Exports
module.exports = exports;
